import React from 'react'
import { ButtonIcon } from 'pepsico-ds'
import { showChartDisplayError, vlaidateLandingPageFilters } from '../Cards/CardUtils';

function BuyerConButtonIcon(enableChartDisplayButton, landingPageFilters, setOpenModal, openModal, capability, disabled=false) {
    return <ButtonIcon
        icon="bar_chart"
        label=""
        onClick={() => {
            if (!enableChartDisplayButton) {
                showChartDisplayError();
            } else {
                vlaidateLandingPageFilters(true, landingPageFilters, setOpenModal, openModal, capability);

            }
        } }
        size="medium"
        disabled={disabled}
        type="default" />;
}


export default BuyerConButtonIcon
